import type { ClientRecordTabId } from '@/lib/clients/resolve-initial-client-tab';

/** D1 Home — bare client record. Matches Cmd-K. */
export function clientHomeHref(clientId: string): string {
  return `/clients/${encodeURIComponent(clientId)}`;
}

export function clientRecordTabHref(clientId: string, tab: ClientRecordTabId): string {
  if (tab === 'overview') return clientHomeHref(clientId);
  return `/clients/${encodeURIComponent(clientId)}?tab=${tab}`;
}

/** Child island Back: originating tab on the record, not a second Home. */
export function clientIslandBackHref(
  clientId: string,
  island:
    | 'medications'
    | 'case-notes'
    | 'devices'
    | 'incidents'
    | 'assessments'
    | 'observations'
    | 'referrals'
    | 'communications'
    | 'clinical',
): string {
  const tab: ClientRecordTabId =
    island === 'observations' || island === 'clinical' || island === 'referrals'
      ? 'clinical'
      : island === 'communications'
        ? 'history'
        : island;
  return clientRecordTabHref(clientId, tab);
}

export type ClientHomeLandingInput = {
  requestedTab?: string | null;
  sahHubVisible: boolean;
  racHubVisible: boolean;
  racJourneyDefaultEnabled?: boolean;
  mixedProgram?: boolean;
  /** care_today_v1: ON never promotes Residential care over Care Today. */
  careToday?: boolean;
};

/** D1: single optimised Home — never default to Journey as a second home. */
export function resolveClientHomeLandingTab(input: ClientHomeLandingInput): ClientRecordTabId {
  const requested = String(input.requestedTab ?? '').trim();
  if (requested) return requested as ClientRecordTabId;
  if (input.careToday) return 'overview';
  const racOnly = input.racHubVisible && !input.sahHubVisible;
  if (racOnly && input.racJourneyDefaultEnabled && !input.mixedProgram) return 'rac-hub';
  return 'overview';
}

export function clientHomeSecondaryViews(input: {
  sahHubVisible: boolean;
  racHubVisible: boolean;
}): ClientRecordTabId[] {
  const views: ClientRecordTabId[] = ['overview'];
  if (input.sahHubVisible) views.push('sah-hub');
  if (input.racHubVisible) views.push('rac-hub');
  return views;
}

export function isClientHomeDefaultTab(tab: string | null | undefined): boolean {
  return tab === 'overview' || tab == null || tab === '';
}
